import makeApiRequest from './makeApiRequest'
import packingRequest from '../request/packing'
import createApiServices from './createApiServices'
import { extendUrlFulfillment } from '../../views/helpers/extenent-url'

const apiRequest = makeApiRequest()
const packingApiRequest = packingRequest()
const fulfillmentApi = createApiServices({
    baseUrl: `${extendUrlFulfillment.url}/api`
})

export const markAsArchived = async (id) => {
    const {data} = await apiRequest({
        url: `/barcode/${id}/mark-as-archived`,
        method: 'POST'
    })

    return data
}

export const changeProductionStatus = async (id, status) => {
    const {data} = await apiRequest({
        url: `/barcode/${id}/production-status`,
        method: 'POST',
        data: {
            status
        }
    })

    return data
}

export const changeProductionStatusV3 = async (id, status) => {
    const {data} = await apiRequest({
        url: `/v3/barcode/${id}/production-status`,
        method: 'POST',
        data: {
            status
        }
    })

    return data
}

export const markHoldShipOrder = async (id, note) => {
    const {data} = await apiRequest({
        url: `/barcode/hold-ship/${id}`,
        method: 'POST',
        data: {
            note
        }
    })

    return data
}

export const removeHoldShip = async (id) => {
    const {data} = await apiRequest({
        url: `/barcode/undo-hold-ship/${id}`,
        method: 'POST'
    })

    return data
}

export const checkAbleToPrint = async (barcode, step) => {
    const {data} = await packingApiRequest({
        url: `/packing/orders/${barcode}/able-to-print?step=${step}`,
        method: 'GET'
    })

    return data
}

export const generateLabelShip = async (orderId, payload = null) => {
    const {data} = await packingApiRequest({
        url: `/packing/v2/orders/${orderId}/generate-label`,
        method: 'POST',
        data: payload
    })

    return data
}

export const markInProduction = async (barcode) => {
    const {data} = await packingApiRequest({
        url: `/packing/barcodes/mark-in-production/${barcode}`,
        method: 'GET'
    })

    return data
}

export const markPackaged = async (barcode) => {
    const {data} = await packingApiRequest({
        url: `/packing/barcodes/mark-packaged/${barcode}`,
        method: 'GET'
    })

    return data
}

export const CombileLabelsShipByTiktokOrder = async (payload) => {
    const { data } = await packingApiRequest({
        url: `/order/barcode/export-labels-to-pdf`,
        method: 'POST',
        data: payload
    })

    return data
}

export const generateLabelByCustomData = async (barcode, payload = null) => {
    const {data} = await packingApiRequest({
        url: `/packing/orders/${barcode}/generate-label-by-custom-data`,
        method: 'POST',
        data: payload
    })

    return data
}

export const generateLabelByLabelId = async (labelId, payload = null) => {
    return fulfillmentApi.makeAuthRequest({
        url: `/label/generate-label/${labelId}`,
        method: 'POST',
        data: payload
    })
}

export const bulkUpdateTags = async (payload) => {
    const { data } = await packingApiRequest({
        url: `/order/barcode/update-tags/bulk`,
        method: 'PUT',
        data: payload
    })

    return data
}